import { useState, useEffect } from "react";

export function useFormPersist(
  key,
  defaultStep = 1,
  defaultSubmitted = false,
  defaultValues = {}
) {
  const getPersistedValues = () => {
    const storedData = sessionStorage.getItem(key);
    if (storedData) {
      try {
        const parsed = JSON.parse(storedData);
        return [
          parsed.step || defaultStep,
          parsed.isSubmitted || defaultSubmitted,
          parsed.formData || defaultValues,
        ];
      } catch (error) {
        console.error("Error parsing stored form data:", error);
        return [defaultStep, defaultSubmitted, defaultValues];
      }
    }
    return [defaultStep, defaultSubmitted, defaultValues];
  };

  const [step, setStep] = useState(() => getPersistedValues()[0]);
  const [isSubmitted, setIsSubmitted] = useState(() => getPersistedValues()[1]);
  const [formData, setFormData] = useState(() => getPersistedValues()[2]);

  useEffect(() => {
    sessionStorage.setItem(
      key,
      JSON.stringify({
        step,
        isSubmitted,
        formData,
      })
    );
  }, [key, step, isSubmitted, formData]);

  return [step, setStep, isSubmitted, setIsSubmitted, formData, setFormData];
}
